import type { AuthContextUser } from 'contexts';

const isUserMlsStaff = (auth?: AuthContextUser) => auth?.org.type === 'mlsStaff' || auth?.parentOrgType === 'mlsStaff';

export default isUserMlsStaff;
